import React from "react";
import LegalPageLayout from "../components/LegalPageLayout";

const ImpressumPage = () => (
  <LegalPageLayout title="Impressum">
    <p className="text-[var(--vortex-text-secondary)]">
      Angaben gemäß § 5 TMG und § 18 MStV:
    </p>

    <section>
      <h2 className="text-xl font-semibold text-[var(--vortex-text-primary)] mt-8 mb-2">
        Serafina Pflegedienst GmbH
      </h2>
      <p>
        Hindenburgstraße 77<br />
        41542 Dormagen
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-[var(--vortex-text-primary)] mt-8 mb-2">
        Vertreten durch
      </h2>
      <p>Geschäftsführer: Bujar Dervari</p>
      <p className="mt-2 text-[var(--vortex-text-secondary)]">
        Geschäftsführung: Bujar Dervari | IK-Nr.: 460542447 | HRB 20619, Amtsgericht Neuss
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-[var(--vortex-text-primary)] mt-8 mb-2">
        Kontakt
      </h2>
      <p>
        Telefon: 02133-21 84 111<br />
        Fax: 02133-21 84 110<br />
        E-Mail:{" "}
        <a
          href="mailto:info@serafina-pflegedienst.de"
          className="text-[var(--vortex-accent-primary)] hover:underline"
        >
          info@serafina-pflegedienst.de
        </a>
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-[var(--vortex-text-primary)] mt-8 mb-2">
        Registereintrag
      </h2>
      <p>
        Eintragung im Handelsregister.<br />
        Registergericht: Amtsgericht Neuss<br />
        Registernummer: HRB 20619
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-[var(--vortex-text-primary)] mt-8 mb-2">
        Institutionelle Kennnummer (IK-Nr.)
      </h2>
      <p>460542447</p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-[var(--vortex-text-primary)] mt-8 mb-2">
        Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
      </h2>
      <p>Bujar Dervari, Hindenburgstraße 77, 41542 Dormagen</p>
    </section>

    <section className="mt-8 pt-6 border-t border-[var(--vortex-border)]">
      <p className="text-sm text-[var(--vortex-text-secondary)]">
        EU-Streitschlichtung: Die Europäische Kommission stellt eine Plattform
        zur Online-Streitbeilegung (OS) bereit:{" "}
        <a
          href="https://ec.europa.eu/consumers/odr/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[var(--vortex-accent-primary)] hover:underline"
        >
          https://ec.europa.eu/consumers/odr/
        </a>
        . Wir sind nicht bereit oder verpflichtet, an
        Streitbeilegungsverfahren vor Verbraucherschlichtungsstellen
        teilzunehmen.
      </p>
    </section>
  </LegalPageLayout>
);

export default ImpressumPage;
